//Carousel.tsx =================================================
import "../Util/Prototypes";

import * as Default from "../Default";

import React from "react";

import { Button, CssBaseline, Dialog, DialogActions, DialogTitle, Icon, IconButton, ImageList, ImageListItem } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";

let imgHeight = 400;
let dialogTitle: string = "";
let url_list: string[] = [];

let showRef: () => void; //Ref to showIt method inside render.
let active = false;

//Show the dialog.
export function show(title: string, urls: string[], imageHeight?: number) {
   dialogTitle = title;
   url_list = urls;
   if (imageHeight) {
      imgHeight = imageHeight;
   }

   active = true;
   showRef(); //Call the "showIt" function.
}

//Render function.
export function Render() {
   //Define state.
   const [visible, setVisible] = React.useState(false); //Set refresh method.

   function showIt() {
      if (url_list) {
         setVisible(true);  //Render and show dialog.
      }
   }

   const showRef2 = React.useRef(showIt);

   //Component did mount. Set module level variables.
   React.useEffect(() => {
      showRef = showRef2.current;
   }, []);

   //Close dialog.
   function handleClose() {
      active = false;
      setVisible(false);  //Hide dialog.
   }

   //css styles.
   const styles: Default.iStyles = {
      row1Container: { display: 'flex', alignItems: 'center', justifyContent: 'space-around', flexWrap: 'wrap' },
   };

   function getImageList() {

      const itemData: { img: string, title: string }[] = [];

      for (const url of url_list) {
         //Get the file name from the url path.
         let sa = url.split("/");
         let name = sa[sa.length - 1];

         sa = name.split(".");
         if (sa.length === 2) {
            name = sa[0];
         }
         itemData.push({ img: url, title: name });
      }

      return (
         <ImageList cols={1} gap={15}>
            {itemData.map((item) => (
               <ImageListItem key={item.img}>
                  <img
                     srcSet={`${item.img}?fit=crop&auto=format&dpr=2 2x`}
                     src={`${item.img}?fit=crop&auto=format`}
                     alt={item.title}
                     loading="lazy"
                     height={imgHeight}
                     title={item.title}
                  />
               </ImageListItem>
            ))}
         </ImageList>
      );
   }

   if (active) {
      return (
         <ThemeProvider theme={Default.theme}>
            <CssBaseline />

            <Dialog
               open={visible}
               onClose={handleClose}
               aria-labelledby="multi-dialog-title"
               aria-describedby="multi-dialog-description"
               fullWidth={true}
               maxWidth="xl"
            >
               <DialogTitle id="multi-dialog-title" style={{ paddingBottom: 0, paddingTop: 9 }}>{dialogTitle}</DialogTitle>

               <IconButton size="large"
                  aria-label="Close"
                  color="primary"
                  onClick={handleClose}
                  sx={{
                     position: "absolute",
                     right: 8,
                     top: 8,
                  }}
               >
                  <Icon>close</Icon>
               </IconButton>,

               <div>
                  {getImageList()}
               </div>

               <DialogActions>
                  <Button onClick={handleClose} color="primary" autoFocus>
                     Close
                  </Button>
               </DialogActions>
            </Dialog>
         </ThemeProvider>
      ); //end return.

   } else {
      return (<div />);
   }

} //end function.
